var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 484,
    viewBox: "0 0 410 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.966 428.19V329.972H0.638019C0.156555 358.378 -0.517495 417.791 0.638019 428.19C2.08241 441.19 16.5263 483.077 72.8576 483.077C117.923 483.077 141.707 446.486 147.966 428.19Z",
    fill: "url(#paint0_linear_2311_7455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.636719 426.738V59.862C5.93282 40.122 25.1914 0.641952 59.8568 0.641952C69.1354 0.641952 85.0824 0.538472 104.171 0.414605C156.4 0.0756964 232.148 -0.415832 259.183 0.641952C283.996 1.61281 346.452 29.9916 382.631 83.5851C347.986 106.475 314.298 126.899 296.851 132.727C287.482 136.896 270.535 137.705 259.393 133.83C239.938 127.065 167.035 117.637 134.919 181.887C102.803 246.136 188.677 240.33 218.72 231.008C222.136 229.949 269.013 213.548 281.016 165.395C284.695 158.116 292.592 148.05 313.248 136.444C331.123 126.401 335.258 124.806 371.401 110.86C377.731 108.417 385.043 105.596 393.582 102.284C404.741 124.592 411.157 150.452 409.4 179.747C400.733 324.186 283.099 358.851 269.294 360.296C255.488 361.74 146.52 360.296 146.52 360.296C110.411 361.74 38.4798 386.872 39.6353 475.847C30.006 474.402 8.72531 462.558 0.636719 426.738Z",
    fill: "url(#paint1_linear_2311_7455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2311_7455",
    x1: 45.0774,
    y1: 407.226,
    x2: 116.793,
    y2: 476.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F61A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A6E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2311_7455",
    x1: -46.8938,
    y1: 0.00000780224,
    x2: 463.243,
    y2: 359.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501066,
    stopColor: "#407EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BB0ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2c1bfb778444dcfe2857f8212cfce1ac.svg";
export { ForwardRef as ReactComponent };